export default __webpack_public_path__ + "static/goruntu-isleme-yazilimlari-730ed75538555d9a2490790f9bc0780b.png";